import { create } from "zustand";

type StepAmounts = {
  [stepId: string]: number;
};

type YachtAmounts = {
  [yachtId: string]: StepAmounts;
};

type AmountsStore = {
  amounts: YachtAmounts;
  setAmount: (yachtId: string, stepId: string, amount: number) => void;
  clearAmounts: () => void;
};

export const useAmountsStore = create<AmountsStore>((set) => ({
  amounts: {},
  setAmount: (yachtId, stepId, amount) =>
    set((state) => ({
      amounts: {
        ...state.amounts,
        [yachtId]: {
          ...state.amounts[yachtId],
          [stepId]: amount,
        },
      },
    })),
  clearAmounts: () => set({ amounts: {} }),
}));
